import { Injectable } from '@angular/core';
import { ApiResponse } from '../model/api-response';
import { FuzzyLogic } from '../model/fuzzyLogic';
import { NotesServiceHistory } from '../model/notesServiceHistory';
import { OiRank } from '../model/oi-rank';
import { Petition } from '../model/petition';
import { PetitionReleaseAddNote } from '../model/petition-release-add-note';
import { Observable } from 'rxjs';
import { CancelTransaction } from '../model/cancel-transaction';
import { CancelTransactionEmailRequest } from '../model/cancel-transaction-email-request';
import { ProblemCorrespondence } from '../model/problem-correspondence';
import { ReleaseAddNote } from '../model/release-add-note';
import { ReviewRspTransactions } from '../model/review-rsp-transactions';
import { Unpaidtransactions } from '../model/unpaidtransactions';
import { VoidRequestResponse } from '../model/voidRequestResponse';
import { SearchTransactions } from '../model/search-transactions';
import { DataService } from './data.service';
import { CheckEscrowStatusEntry } from '../model/check-escrow-status-entry';
import { CancelTransactionResponse } from '../model/cancel-transaction-response';
import { CancellationValidity } from '../model/cancellation-validity';
import { EscrowStatusEntryForSendApi } from '../model/escrow-status-entry-for-sendapi';
import { CancelTransactionBySendApi } from '../model/cancel-transaction-by-sendapi';
import { TransactionDetails } from '../model/get-transaction-details';
import { TransactionHoldHistoryResponse } from '../model/transactionHoldHistoryResponse';
import { RetransmitTransaction } from '../model/retransmit-transaction';
import { AccountDetails } from '../model/account-details';
import { TransactionHistoryResponse } from '../model/transactionHistoryResponse';
import { PayerRejectedTransaction } from '../model/payer-rejected-transaction';
import { OpenCloseInvestigation } from '../model/open-close-investigation';
import { AddComment } from '../model/add-comment';
import { ComplaintRfiPetition } from '../model/complaint-rfi-petition';
import { TravelRuleInfo } from '../model/travel-rule-info';
import { ChangeRspPreValidationInput } from '../model/change-rsp/change-rsp-pre-validation-input';
import { BankFilters } from '../model/bank-filters';
import { Bank } from '../model/bank';
import { RspDetails } from '../model/rsp-details';
import { PaidInfo } from '../model/paid-info';
import { ChangeNameSenderRequest } from '../model/change-name-sender-request';
import { ChangeNameRecipientReceipient } from '../model/change-name-recipient-receipient';
import { RspEmailDetails } from '../model/rsp-email-details';
import { CancelTransactionRequest } from '../model/cancel-transaction-request';
import { CancelTransactionLoadResponse } from '../model/cancel-transaction-load-response';
import { TransactionDetail } from '../model/transaction-detail-request';
import { ProcessCancellationResponse } from '../model/process-cancellation-response';
import { ChangeRequestFields } from '../model/change-request-fields';
import { RequestType } from '../model/maker-checker/request-type';
import { GetRequest } from '../model/maker-checker/get-request';
import { ReviewRequestDetail } from '../model/maker-checker/review-request-detail';
import { RequestDetail } from '../model/maker-checker/request-detail';
import { RequestInput } from '../model/maker-checker/request-input';
import { UpdateRequest } from '../model/maker-checker/update-request';
import { SearchOiDetails } from '../model/search-oi-details';
import { RateListRequest } from '../model/rate-list-request';
import { GetOiDetails } from '../model/get-oi-details';
import { RSPChangeLog } from '../model/rsp-change-log';
import { RSPLog } from '../model/RSP-Logs';
import { RSPSystemTypeLogs } from '../model/RSP-system-type-logs';
import { ICAModal } from '../model/ica-modal';
import { LocationAlternateNamesRequest } from '../model/location-alternate-names-request';
import { PayerDetailsResponse } from '../model/rsp-setup/payer-details-response';
import { PayerDetailsInformation } from '../model/rsp-setup/payer-details-information';
import { ReceivingChannelLogRequest } from '../model/rsp-setup/receiving-channel-log-request';
import { SetupLogRequest } from '../model/rsp-setup/setup-log-request';
import { TransactionsUnderInvestigation } from '../model/transactions-under-investigation';
import { CancelledPaid } from '../model/cancelled-paid';
import { PaidStatusInquiry, SendInquiryEmail } from '../model/paid-status-inquiry';

@Injectable({
  providedIn: 'root'
})
export class BackofficeService {

  constructor(private dataService: DataService) { }  

  postVoidReqRes(body: VoidRequestResponse): Observable<VoidRequestResponse> {
    return this.dataService.postBackOffice<VoidRequestResponse[]>('/backoffice/voidrequestresponse/getvoidrequestresponse', body)
  }

  postVoidReqResExportToExcel(body: VoidRequestResponse): Observable<VoidRequestResponse> {
    return this.dataService.postBackOffice<any>('/backoffice/voidrequestresponse/exportvoidrequestresponse', body, 'blob')
  }

  postReviewRSPTransactions(body: ReviewRspTransactions): Observable<ReviewRspTransactions> {
    return this.dataService.postBackOffice<ReviewRspTransactions[]>('/backoffice/reviewpayertransactions/gettransactions', body)
  }

  postReviewPayerExportToExcel(body: any): Observable<any> {
    return this.dataService.postBackOffice<any>('/backoffice/reviewpayertransactions/exportreviewpayertransactions', body, 'blob')
  }

  postReviewPayerBlueBalloonLogsGridDataExportToExcel(body: any): Observable<any> {
    return this.dataService.postBackOffice<any>('/backoffice/reviewpayertransactions/exportblueballoonlogsbygriddata', body, 'blob')
  }

  postReviewPayerBlueBalloonLogsPinsListExportToExcel(body: any): Observable<any> {
    return this.dataService.postBackOffice<any>('/backoffice/reviewpayertransactions/exportblueballoonlogs', body, 'blob')
  }

  postProblemCorrespondence(body: ProblemCorrespondence): Observable<ProblemCorrespondence> {
    return this.dataService.postBackOffice<ProblemCorrespondence[]>('/backoffice/problemcorrespondence/getproblemcorrespondence', body)
  }

  postProblemCorrespondenceExportToExcel(body: ProblemCorrespondence): Observable<ProblemCorrespondence> {
    return this.dataService.postBackOffice<any>('/backoffice/problemcorrespondence/exportproblemscorrespondence', body, 'blob')
  }

  postReleaseWithAddNote(body: ReleaseAddNote): Observable<ReleaseAddNote> {
    return this.dataService.postBackOffice<any>('/backoffice/problemcorrespondence/releasewithaddnote', body)
  }

  getOiRanks(): Observable<ApiResponse<OiRank[]>> {
    return this.dataService.getBackOffice<OiRank[]>('/backoffice/petitions/getranks')
  }

  postPetitions(body: Petition): Observable<Petition> {
    return this.dataService.postBackOffice<Petition[]>('/backoffice/petitions/getpetitions', body)
  }

  postResetAge(petitionId: string): Observable<any> {
    return this.dataService.postBackOffice<any>('/backoffice/petitions/resetage?PetitionId=' + petitionId, null)
  }

  postPetitionsExportToExcel(body: Petition): Observable<Petition> {
    return this.dataService.postBackOffice<any>('/backoffice/petitions/exportpetitions', body, 'blob')
  }

  postPetitionReleaseWithAddNote(body: PetitionReleaseAddNote): Observable<PetitionReleaseAddNote> {
    return this.dataService.postBackOffice<any>('/backoffice/petitions/releasewithaddnote', body)
  }

  getPetitionById(data: any): Observable<any> {
    return this.dataService.getBackOffice<any[]>('/backoffice/petitions/getpetitiondetailsbyid?PetitionId=' + data.petitionId)
  }

  disablePredefinedResponses(body: any): Observable<any> {
    return this.dataService.postBackOffice<any>('/backoffice/petitions/disablepredefinedresponses', body)
  }

  postNotesServiceHistory(body: NotesServiceHistory): Observable<ApiResponse<NotesServiceHistory>>{
    return this.dataService.postBackOffice<any[]>('/backoffice/blueballoon/getblueballoonservicehistory', body)
  }

  postViewLog(body: NotesServiceHistory): Observable<NotesServiceHistory> {
    return this.dataService.postBackOffice<NotesServiceHistory[]>('/backoffice/blueballoon/getblueballoonviewlog', body)
  }

  postFuzzyMatchBeneficiaryName(body: FuzzyLogic) {
    return this.dataService.postBackOffice<any>('/backoffice/petitions/fuzzymatchbeneficiaryname', body)
  }

  postUnpaidtransactions(body: Unpaidtransactions): Observable<ApiResponse<ProblemCorrespondence>> {
    return this.dataService.postBackOffice<Unpaidtransactions[]>('/backoffice/processunpaidtransactions/getunpaidtransactions', body)
  }

  postUnpaidtransactionsExportToExcel(body: Unpaidtransactions): Observable<Unpaidtransactions> {
    return this.dataService.postBackOffice<any>('/backoffice/processunpaidtransactions/exportunpaidtransactions', body, 'blob')
  }

  postCheckEscrowStatusEntryForSendApi(body: EscrowStatusEntryForSendApi): Observable<ApiResponse<CheckEscrowStatusEntry[]>> {
    return this.dataService.postBackOffice<EscrowStatusEntryForSendApi>('/backoffice/processunpaidtransactions/checkescrowstatusentryforsendapi', body)
  }

  postCancelTransactionBySendApi(body: CancelTransactionBySendApi): Observable<CancelTransactionResponse> {
    return this.dataService.postBackOffice<CancelTransactionBySendApi>('/backoffice/processunpaidtransactions/canceltransactionsbysendapi', body)
  }


  postCancelTransactionByEmailRequest(body: CancelTransactionEmailRequest): Observable<CancelTransactionResponse> {
    return this.dataService.postBackOffice<CancelTransactionEmailRequest>('/backoffice/processunpaidtransactions/canceltransactionsbyemailrequest', body)
  }

  bulkCancellationValidity(body: CancelTransaction[]): Observable<CancellationValidity> {
    return this.dataService.postBackOffice<CancelTransaction[]>('/backoffice/cancellations/bulkcancellationvalidity', body)
  }

  processBulkCancellation(body: CancelTransactionRequest[]): Observable<ApiResponse<ProcessCancellationResponse>> {
    return this.dataService.postBackOffice<CancelTransactionRequest[]>('/backoffice/processunpaidtransactions/bulkcancellationprocess', body)
  }

  cancelTransaction(body: CancelTransactionRequest): Observable<ApiResponse<any>> {
    return this.dataService.postBackOffice<CancelTransactionRequest>('/backoffice/transactionoperations/canceltransaction', body)
  }

  getCancelTransactionPreLoadInformation(oiId: string, invoiceId: string, mainBranchId: string, isPaid: boolean): Observable<ApiResponse<CancelTransactionLoadResponse>> {
    return this.dataService.getBackOffice<any>('/backoffice/transactionoperations/getcanceltransactionpreloadinformation?oiId='+ oiId +'&invoiceId=' + invoiceId + '&mainBranchId=' + mainBranchId +'&isPaid=' + isPaid);
  }

  postGetTransactionDetails(body: SearchTransactions): Observable<SearchTransactions> {
    return this.dataService.postBackOffice<SearchTransactions>('/backoffice/searchtransaction/searchtransactionbyoiandinvoiceids', body)
  }

  postSearchTransactionByTFPin(tfPin: string): Observable<SearchTransactions> {
    return this.dataService.postBackOffice<SearchTransactions>('/backoffice/searchtransaction/searchtransactionbytfpin?TFPIN=' + tfPin, null)
  }

  postSearchTransactionByPPN(ppn: string): Observable<SearchTransactions> {
    return this.dataService.postBackOffice<SearchTransactions>('/backoffice/searchtransaction/searchtransactionbyppns?prePrintedNumber=' + ppn, null)
  }

  postSearchTransactionByExternalReferenceNumber(externalReferenceNumber: string): Observable<SearchTransactions> {
    return this.dataService.postBackOffice<SearchTransactions[]>('/backoffice/searchtransaction/searchtransactionbyexternalreference?sExternalReference=' + encodeURIComponent(externalReferenceNumber), null)
  }

  postSearchTransactionByNameAndId(body: SearchTransactions): Observable<SearchTransactions> {
    return this.dataService.postBackOffice<SearchTransactions[]>('/backoffice/searchtransaction/searchtransactionbynameandid', body)
  }

  postSearchTransactionByReferenceNumber(referenceId: string, mainBranchId: string): Observable<SearchTransactions> {
    return this.dataService.postBackOffice<SearchTransactions[]>('/backoffice/searchtransaction/searchtransactionbyreferencenumber?ReferenceId=' + referenceId + '&MainBranchId=' + mainBranchId, null)
  }

  postSearchTransactionByOI(body: SearchTransactions): Observable<SearchTransactions> {
    return this.dataService.postBackOffice<SearchTransactions[]>('/backoffice/searchtransaction/searchtransactionbyoi', body)
  }

  postExportTransactionByNameAndId(body: SearchTransactions): Observable<SearchTransactions> {
    return this.dataService.postBackOffice<any>('/backoffice/searchtransaction/exporttransactionbyname', body, 'blob')
  }

  postExportTransactionByExternalReferenceNumber(externalReferenceNumber: string): Observable<SearchTransactions> {
    return this.dataService.postBackOffice<any[]>('/backoffice/searchtransaction/exporttransactionsbyexternalreference?sExternalReference=' + encodeURIComponent(externalReferenceNumber), null, 'blob')
  }

  postExportTransactionByOI(body: SearchTransactions): Observable<SearchTransactions> {
    return this.dataService.postBackOffice<any>('/backoffice/searchtransaction/exporttransactionsbyoi', body, 'blob')
  }

  postTransactionDetails(body: TransactionDetails): Observable<any> {
    return this.dataService.postBackOffice<any>('/backoffice/transactiondetails/gettransactiondetails', body)
  }

  getTransactionOiInformation(oiId: string): Observable<any> {
    return this.dataService.getBackOffice<any>('/backoffice/transactiondetails/gettransactionoiinformation?OIId=' + oiId);
  }

  postTransactionDetailsHistory(body: NotesServiceHistory): Observable<NotesServiceHistory> {
    return this.dataService.postBackOffice<NotesServiceHistory>('/backoffice/transactiondetails/gettransactiondetailshistory', body)
  }

  postGetLocationAlternateNames(body: any): Observable<any>{
    return this.dataService.postBackOffice<any>('/backoffice/locationsalternatenames/getlocationsalternatenames', body)
  }

  postSaveLocationAlternateNames(body: LocationAlternateNamesRequest): Observable<any>{
     return this.dataService.postBackOffice<LocationAlternateNamesRequest>('/backoffice/locationsalternatenames/savelocationsalternatenames', body)
  }

  
  postTransactionDetailsTFPin(body: NotesServiceHistory): Observable<ApiResponse<NotesServiceHistory>>{
    return this.dataService.postBackOffice<any[]>('/backoffice/transactiondetails/gettransactiondetailstfpinhistory', body);
  }

  postIsPayerRejectedTransaction(paylod: PayerRejectedTransaction): Observable<ApiResponse<PayerRejectedTransaction>> {
    return this.dataService.postBackOffice<any>('/backoffice/transactioninformations/getispayerrejectedtransaction', paylod);
  }

  checkIsDxPayer(mainBranchId: string): Observable<ApiResponse<string>> {
    return this.dataService.getBackOffice<any>('/backoffice/transactioncancellations/checkdxppayers?MainBranchId=' + mainBranchId);
  }

  postTransactionStatus(payload: NotesServiceHistory): Observable<ApiResponse<TransactionHistoryResponse[]>> {
    return this.dataService.postBackOffice<TransactionHistoryResponse[]>('/backoffice/transactiondetails/gettransactiondetailshistory', payload);
  }

  postHoldTransaction(payload: NotesServiceHistory): Observable<ApiResponse<TransactionHoldHistoryResponse[]>> {
    return this.dataService.postBackOffice<TransactionHoldHistoryResponse[]>('/backoffice/transactiondetails/gettransactiondetailsholdhistory', payload);
  }

  postRetransmitTransaction(payload: RetransmitTransaction): Observable<ApiResponse<any>> {
    return this.dataService.postBackOffice<any>('/backoffice/transactioninformations/postretransmittransaction', payload);
  }

  postAccountDetails(body: AccountDetails): Observable<AccountDetails> {
    return this.dataService.postBackOffice<any>('/backoffice/transactiondetails/postaccountdetails', body)
  }

  postPinAndPpnDetails(body: NotesServiceHistory): Observable<any> {
    return this.dataService.postBackOffice<NotesServiceHistory>('/backoffice/transactiondetails/getpinandppndetails', body)
  }

  postRecipientAccount(body: NotesServiceHistory): Observable<ApiResponse<NotesServiceHistory>> {
    return this.dataService.postBackOffice<any>('/backoffice/transactiondetails/getrecipientaccount', body);
  }

  postOpenCloseInvestigation(body: OpenCloseInvestigation): Observable<ApiResponse<OpenCloseInvestigation>> {
    return this.dataService.postBackOffice<any>('/backoffice/blueballoon/opencloseinvestigations', body);
  }

  postChangeClave(payload: NotesServiceHistory): Observable<ApiResponse<NotesServiceHistory>> {
    return this.dataService.postBackOffice<any>('/backoffice/transactionoperations/postchangeclave', payload);
  }

  postRecipientTransactionDetails(body: any): Observable<ApiResponse<any>> {
    return this.dataService.postBackOffice<any>('/backoffice/transactiondetails/postrecipienttransactiondetails', body);
  }

  postSenderTransactionDetails(body: any): Observable<ApiResponse<any>> {
    return this.dataService.postBackOffice<any>('/backoffice/transactiondetails/postsendertransactiondetails', body);
  }

  postAddComment(body: any): Observable<ApiResponse<AddComment>> {
    return this.dataService.postBackOffice<any>('/backoffice/blueballoon/addcomments', body);
  }

  postCancelReverse(payload : NotesServiceHistory) : Observable<ApiResponse<any>>{
    return this.dataService.postBackOffice<any>('/backoffice/transactionoperations/postcancelreverse', payload);
  }
  saveRfiPetition(body: ComplaintRfiPetition): Observable<ApiResponse<string>>{
    return this.dataService.postBackOffice<ApiResponse<string>>('/backoffice/transactionoperations/saveandcreatepetitions', body);
  }

  manageComplaints(body: ComplaintRfiPetition): Observable<ApiResponse<string>>{
    return this.dataService.postBackOffice<ApiResponse<string>>('/backoffice/transactionoperations/managecomplaints', body);
  }

  getIsChangeCityAllowed(payload: NotesServiceHistory): Observable<ApiResponse<any>> {
    return this.dataService.postBackOffice('/backoffice/transactioninformations/getischangecityallowed', payload);
  }

  getShowTown(CountryId: string): Observable<ApiResponse<any>> {
    return this.dataService.getBackOffice('/backoffice/transactiondetails/getshowtown?CountryId=' + CountryId);
  }

  getTravelRuleInformations(recipientId: string): Observable<ApiResponse<TravelRuleInfo>>{
    return this.dataService.getBackOffice('/backoffice/transactionoperations/gettravelruleinformations?ReceiverId=' + recipientId)
  }
  validateChangeRsp(body: ChangeRspPreValidationInput): Observable<ApiResponse<boolean>> {
    return this.dataService.postBackOffice<ApiResponse<boolean>>('/backoffice/transactionoperations/validatechangersp', body);
  }

  getBanks(filter: BankFilters): Observable<ApiResponse<Bank[]>> {
    return this.dataService.postBackOffice<ApiResponse<Bank[]>>('/backoffice/transactioninformations/getbanks', filter);
  }

  getRspList(body: any): Observable<ApiResponse<RspDetails[]>> {
    return this.dataService.postBackOffice<ApiResponse<RspDetails[]>>('/backoffice/transactioninformations/getrsplist', body);
  }

  changeRsp(body: any): Observable<ApiResponse<boolean>> {
    return this.dataService.postBackOffice<ApiResponse<boolean>>('/backoffice/transactionoperations/changersp', body);
  }

  getTotalInvoices(oiId: string): Observable<ApiResponse<number>> {
    return this.dataService.getBackOffice('/backoffice/transactiondetails/gettotalinvoices?OiId=' + oiId);
  }
  postVoidRequest(data: TransactionDetails): Observable<ApiResponse<string>> {
    return this.dataService.postBackOffice('/backoffice/transactionoperations/canceltransactionrequest', data);
  }

  getPaidInformation(payload :NotesServiceHistory): Observable<ApiResponse<any>>{
    return this.dataService.postBackOffice('/backoffice/transactionoperations/getpaidinformation', payload);
  }

  postPaidInformation(payload : PaidInfo): Observable<ApiResponse<PaidInfo>>{
    return this.dataService.postBackOffice('/backoffice/transactionoperations/postpaidinformation', payload);
  }

  postChangenameSender(body: ChangeNameSenderRequest): Observable<ChangeNameSenderRequest> {
    return this.dataService.postBackOffice<ApiResponse<string>>('/backoffice/transactionoperations/changenamesender', body)
  }

  postChangenameReceipient(body: ChangeNameRecipientReceipient): Observable<ChangeNameRecipientReceipient> {
    return this.dataService.postBackOffice<ApiResponse<string>>('/backoffice/transactionoperations/changenamereceiver', body)
  }

  getTransactionStatus(payload :TransactionDetail): Observable<ApiResponse<string>>{
    return this.dataService.postBackOffice('/backoffice/transactioninformations/gettransactionstatus', payload);
  }

  getRSPEmailDetails(payload :TransactionDetail): Observable<ApiResponse<RspEmailDetails>>{
    return this.dataService.postBackOffice('/backoffice/transactioninformations/getrspemaildetails', payload);
  }
  changeRequest(body: any): Observable<ApiResponse<boolean>> {
    return this.dataService.postBackOffice<ApiResponse<boolean>>('/backoffice/transactionoperations/postchangerequest', body);
  }

  getChangeRequestFields(body: TransactionDetail): Observable<ApiResponse<ChangeRequestFields>> {
    return this.dataService.postBackOffice<ApiResponse<ChangeRequestFields>>('/backoffice/transactioninformations/getmodifyrequestfileds', body);
  }

  postSearchDetails(body: SearchOiDetails): Observable<SearchOiDetails> {
    return this.dataService.postBackOffice<SearchOiDetails[]>('/backoffice/searchoirsp/searchoidetails', body)
  }

  exportSearchOiDetails(body: SearchOiDetails): Observable<any> {
    return this.dataService.postBackOffice<any>('/backoffice/searchoirsp/exportsearchoidetails', body, 'blob')
  }

  postSearchRateList(body: RateListRequest): Observable<RateListRequest> {
    return this.dataService.postBackOffice<ApiResponse<any>>('/backoffice/searchoirsp/oiratelist', body)
  }

  getRequestTypes(): Observable<ApiResponse<RequestType[]>>{
    return this.dataService.getBackOffice('/backoffice/ReviewRequests/getallrequesttypes');
  }

  getOpenRequests(input: RequestInput): Observable<ApiResponse<RequestDetail[]>>{
    return this.dataService.postBackOffice('/backoffice/ReviewRequests/getopenrequests', input);
  }

  getRequestByFilter(input: RequestInput): Observable<ApiResponse<RequestDetail[]>> {
    return this.dataService.postBackOffice('/backoffice/ReviewRequests/getrequestbyfilter', input)
  }

  getRequestdetail(body: GetRequest): Observable<GetRequest> {
    return this.dataService.postBackOffice<ApiResponse<ReviewRequestDetail>>('/backoffice/ReviewRequests/getrequestdetail', body)
  }

  updateReviewRequest(body: UpdateRequest): Observable<UpdateRequest> {
    return this.dataService.postBackOffice<ApiResponse<any>>('/backoffice/ReviewRequests/updaterequest', body)
  }

  approveReviewRequest(body: UpdateRequest): Observable<UpdateRequest> {
    return this.dataService.postBackOffice<ApiResponse<any>>('/backoffice/ReviewRequests/approverequest', body)
  }
  
  getOIDetails(payload : GetOiDetails): Observable<ApiResponse<GetOiDetails>>{
    return this.dataService.postBackOffice('/backoffice/searchoirsp/oidetails', payload);
  }

  getOiEmailConfiguration(payload: any): Observable<ApiResponse<any>> {
    return this.dataService.postBackOffice('/backoffice/searchoirsp/oiemailconfigurations', payload);
  }

  getCoverageLog(oiId: string): Observable<ApiResponse<any>> {
    return this.dataService.getBackOffice('/backoffice/searchoirsp/oicoveragelogs?OiId=' + oiId);
  }

  getBankLog(oiId: string): Observable<ApiResponse<any>> {
    return this.dataService.getBackOffice('/backoffice/searchoirsp/oibanklogs?OiId=' + oiId);
  }

  getReceivingChannelLog(oiId: string): Observable<ApiResponse<any>> {
    return this.dataService.getBackOffice('/backoffice/searchoirsp/oimodepaylogs?OiId=' + oiId);
  }

  getBranchStatus(oiId: string): Observable<ApiResponse<any>> {
    return this.dataService.getBackOffice('/backoffice/searchoirsp/getbranchstatuslog?BranchId=' + oiId);
  }

  getSwiftCodeLog(oiId: string): Observable<ApiResponse<any>> {
    return this.dataService.getBackOffice('/backoffice/searchoirsp/oiswiftcodelogs?OiId=' + oiId);
  }

  getBranchChangesLogs(body: any): Observable<ApiResponse<RSPChangeLog>> {
    return this.dataService.postBackOffice('/backoffice/searchoirsp/getbranchchangeslogs', body)
  }

  getBranchLogs(body: any): Observable<ApiResponse<RSPLog>> {
    return this.dataService.postBackOffice('/backoffice/searchoirsp/getbranchlogs', body)
  }

  getOISystemTypesLogs(body: any): Observable<ApiResponse<RSPSystemTypeLogs>> {
    return this.dataService.postBackOffice('/backoffice/searchoirsp/getoisystemtypeslogs', body);
  }
  
  getBranchRelationship(searchCriteria: any): Observable<ApiResponse<any>> {
    return this.dataService.postBackOffice('/backoffice/searchoirsp/oirelationshiprsp', searchCriteria);
  }

  getOiRedFlagComments(oiId: string): Observable<ApiResponse<any>> {
    return this.dataService.getBackOffice('/backoffice/searchoirsp/oiredflagcomments?OiId=' + oiId);
  }

  getOiRedFlagCount(oiId: string): Observable<ApiResponse<any>> {
    return this.dataService.getBackOffice('/backoffice/searchoirsp/oiredflagcount?OiId=' + oiId);
  }

  exportRelationshipRsp(body : any): Observable<any> {
    return this.dataService.postBackOffice('/backoffice/searchoirsp/exportoirelationshiprsp', body, 'blob');
  }

  getIcaConfiguration(body: ICAModal): Observable<any> {
    return this.dataService.postBackOffice('/backoffice/searchoirsp/associatedicamappings', body);
  }

  getOwnerInformation(oiId: string): Observable<any> {
    return this.dataService.getBackOffice('/backoffice/searchoirsp/getownerinformations?OiId=' + oiId);
  }

  getRspCsSetup(mainBranchId: string): Observable<ApiResponse<PayerDetailsResponse>> {
    return this.dataService.getBackOffice('/backoffice/rspgroupmaintainance/getpayerinformations?MainBranchId=' + mainBranchId);
  }

  postRspCsSetup(body: PayerDetailsInformation): Observable<any> {
    return this.dataService.postBackOffice<any>('/backoffice/rspgroupmaintainance/postpayerinformations', body);
  }

  getReceivingChannelLogs(body: ReceivingChannelLogRequest): Observable<ApiResponse<any>> {
    return this.dataService.postBackOffice<ApiResponse<any>>('/backoffice/rspgroupmaintainance/getreceivingchannellogs', body)
  }

  getSetupLogs(body: SetupLogRequest): Observable<ApiResponse<any>> {
    return this.dataService.postBackOffice<ApiResponse<any>>('/backoffice/rspgroupmaintainance/getrspcssetuplogs', body)
  }

  postSetupLogsExportToExcel(body: SetupLogRequest): Observable<any> {
    return this.dataService.postBackOffice<any>('/backoffice/rspgroupmaintainance/exportpostsetuplogs', body, 'blob')
  }
  
  postGetTransactionsUnderInvestigation(body: TransactionsUnderInvestigation): Observable<TransactionsUnderInvestigation>{
    return this.dataService.postBackOffice<any[]>('/backoffice/transactionsunderinvestigations/gettransactionsunderinvestigations', body)
  }

  postExcelExportTransactionsUnderInvestigation(body: TransactionsUnderInvestigation): Observable<TransactionsUnderInvestigation>{
    return this.dataService.postBackOffice<any[]>('/backoffice/transactionsunderinvestigations/exporttransactionsunderinvestigations', body, 'blob')
  }

  postInsertBlueBalloonViewLog(body: any): Observable<ApiResponse<boolean>> {
    return this.dataService.postBackOffice<any>('/backoffice/blueballoon/insertblueballoonviewlog', body);
  }

  postCancelledPaidexporttoexcel(body: CancelledPaid): Observable<CancelledPaid> {
    return this.dataService.postBackOffice<any[]>('/backoffice/transactioncancellations/exportcancelpaidTransactions', body, 'blob')
  }

  postCancelledPaid(body: CancelledPaid): Observable<CancelledPaid> {
    return this.dataService.postBackOffice<any[]>('/backoffice/transactioncancellations/getcancelpaidtransactions', body)
  }

  getPayoutCurrencyLogs(oiId: string): Observable<ApiResponse<any>> {
    return this.dataService.getBackOffice('/backoffice/searchoirsp/getpayoutcurrencylog?OiId=' + oiId);
  }

  postPaidStatusInquiryexporttoexcel(body: PaidStatusInquiry): Observable<PaidStatusInquiry>{
    return this.dataService.postBackOffice<any>('/backoffice/paidstatusinquiry/exportpaidstatusinquiry', body, 'blob')
  }
  postPaidStatusInquiry(body: PaidStatusInquiry): Observable<PaidStatusInquiry>{
    return this.dataService.postBackOffice<any[]>('/backoffice/paidstatusinquiry/getpaidstatusinquiry', body)
  }
  sendInquiryEmail(body: SendInquiryEmail) : Observable<any>{
    return this.dataService.postBackOffice<any>('/backoffice/paidstatusinquiry/sendemails', body);
  }
}
